/** @format */

import React, { useCallback, useEffect, useMemo, useState } from 'react';
import TariffInterface from '../../../interfaces/billing/TariffInterface';
import BasePricelistInterface from '../../../interfaces/billing/BasePricelistInterface';
import Loader from '../../../components/Loaders/Loader';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TableRow,
    Card,
    Button,
} from '@material-ui/core';
import I18n from '../../../components/Translate/I18n';
import { CustomMinimalTabs } from '../../../components/CustomMinimalTabs/CustomMinimalTabs';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { configDefault } from '../../../core/config';
import { tariffConstants } from '../../../modules/tariffs/actions';
import Filter from '../../../interfaces/forms/Filter';
import Order from '../../../interfaces/forms/Order';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { useDispatch } from 'react-redux';
import LinearBillingUpload, { LinearBillingUploadCollectionInterface } from '../../../interfaces/billing/LinearBillingUpload';
import PaperedTable from '../../../components/Table/PaperedTable';
import TableHeaderContentCell from '../../../components/Table/TableHeaderContentCell';
import CancelButton from '../../../components/Buttons/CancelButton';
import PricelistInterface from '../../../interfaces/billing/PricelistInterface';
import { roles, UserRoleHelper } from '../../../helpers/UserRoleHelper';
import EditButton from '../../../components/Buttons/EditButton';
import DeleteButton from '../../../components/Buttons/DeleteButton';
import { DateHelperTs } from '../../../helpers/DateHelperTs';
import Pager from '../../../components/Adescom/Pager';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { makeStyles } from '@material-ui/core/styles';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import CustomTextButton from '../../../components/Buttons/CustomTextButton';
import Paper from '@material-ui/core/Paper';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import CardBody from '../../../components/Card/CardBody';
import COLORS from '../../../assets/themes/OPL/colors';
import { Auth } from '../../../modules/auth/Auth';
import { apiCall } from '../../../core/apiCall';
import { NotificationHelper } from '../../../helpers/NotificationHelper';

const useStyle = makeStyles(adescomStyle);

interface UploadPricelistFile {
    tariff: TariffInterface;
    reloadData: () => void;
}

export const UploadPricelistFile = (props: UploadPricelistFile): React.ReactElement => {
    const tariff = props.tariff;
    const reloadData = props.reloadData;

    const dispatch = useDispatch();
    const classes = useStyle();

    const [hideUpload, setHideUpload] = useState<boolean>(true);
    const [visibleLoader, setVisibleLoader] = useState<boolean>(false);
    const [file, setFile] = useState<File | null>(null);

    const selectFile = (event: any): void => {
        const file = event.target.files[0];
        console.log(file);
        setFile(file);
        setHideUpload(false);
    };

    const upload = (): void => {
        if (file) {
            const data = new FormData();
            data.append('file', file);
            data.append('platformUserId', Auth.getUserId().toString());
            data.append('tariffId', tariff.id.toString());
            apiCall
                .uploadFile(FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/linear_billing_uploads')), data)
                .then((response: any): void => {
                    setFile(null);
                    setHideUpload(true);
                    reloadData();
                    NotificationHelper.notifySuccess('pricelists:import.import_queued', dispatch);
                })
                .catch((error: any): any => {
                    if (error && error.response && error.response.data && typeof error.response.data === 'string') {
                        NotificationHelper.notifyError(error.response.data, dispatch);
                    } else {
                        NotificationHelper.notifyError('pricelists:import.import_queue_error', dispatch);
                    }
                });
        }
    };

    return (
        <Card>
            <CardBody>
                <GridItem xs={12}>
                    <label htmlFor="btn-upload">
                        <input
                            id="btn-upload"
                            name="btn-upload"
                            style={{ display: 'none' }}
                            type="file"
                            onChange={selectFile}
                            accept="text/csv, .csv"
                        />
                        <Button
                            className={`${classes.button} ${classes.md}`}
                            style={{ backgroundColor: COLORS.MAIN.PRIMARY, height: 50 }}
                            component="span"
                        >
                            <I18n trans="pricelists:import.select_file" />
                        </Button>
                    </label>
                    {!hideUpload && (
                        <CustomTextButton size={'lg'} color={'primary'} label={'pricelists:import.send'} callback={upload} callbackParam={{}} />
                    )}
                </GridItem>
                <Loader visible={visibleLoader} />
            </CardBody>
        </Card>
    );
};
